import Cookies from 'js-cookie'
import axios from 'axios';

const actions = {
  getNotification({ commit }) {
    if (Cookies.get('userdata') !== undefined) {
      const auth = JSON.parse(Cookies.get('userdata'))
      axios.get(`${process.env.VUE_APP_BASE_URL_API}/v1/notification`, {
        headers: {
          Authorization: 'Bearer ' + auth.key.token
        },
        params: {
          page: 1,
          per_page: 10,
          orderby: 'created_at',
          sort: 'desc',
          is_read: false,
        }
      }).then(response => {
        commit('SET_NOTIFICATION', { notifications: response.data.data.rows, total: response.data.data.total_unread })
      })
    }
  },
}

export default actions
